const isEmptyCode = `import { isEmpty } from 'cristatus';

// Check if a string is empty.
const isEmptyString = isEmpty(""); // true

// Check if an array is empty.
const isEmptyArray = isEmpty([]); // true

// Check if an object is empty.
const isEmptyObject = isEmpty({}); // true
`;

export default isEmptyCode;
